module.exports = __webpack_public_path__ + "static/img/cybercrime_3.6f647ca6.png";